import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "am_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const fileUrl = (id, token = getToken()) => `${API}/files/${id}${token ? `?auth=${token}` : ""}`;

export const money = (v) => (v === undefined || v === null ? "—" : `USD ${Number(v).toFixed(2)}`);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-ZW", { day: "numeric", month: "short", year: "numeric" }) : "—";
